import { call, select, takeLatest } from 'redux-saga/effects'
import { CustomSignaturesConstants } from '../store/customSignature.constants'
import { getCustomSignaturesSelector } from '../selectors/getCustomSignature.selectors'
import { ICustomFormsSignatureState } from '../store/customSignature.types'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import Logger from '../../../services/logger.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* saveCustomSignature() {
  const pcrID: string = yield select(getPcrIdSelector)

  if (pcrID) {
    try {
      const serviceId: string = yield select(getServiceIdSelector)
      const customSignature: ICustomFormsSignatureState = yield select(getCustomSignaturesSelector)
      const { prFormsSignature, prFormsCustom, customSignatureClientData } = customSignature
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const pcrDocUpdated = {
        ...pcrDoc,
        prFormsCustom,
        prFormsSignature,
        __customSignatureClientData: customSignatureClientData,
      }
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      Logger.error(`saveCustomSignature() error: ${e}`)
    }
  }
}

export function* saveCustomSignatureSaga() {
  yield takeLatest(
    [CustomSignaturesConstants.SAVE_CUSTOM_SIGNATURE_TO_PCR, CustomSignaturesConstants.CUSTOM_SIGNATURE_CLEAR_ALL],
    performWithMutexHOG,
    saveCustomSignature
  )
}
